var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GZ-ModalMainTmpl',{attrs:{"icon":"icon-flag"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Добавить юридическое лицо")]),_c('section',{attrs:{"slot":"content"},slot:"content"},[_c('AddServiceEntityForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }